import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Store} from '@ngxs/store';
import {lastValueFrom, Observable, throwError} from 'rxjs';
import {FirebaseApp} from '@angular/fire/app';
import {
  Auth,
  getAuth,
} from '@angular/fire/auth';

import {Firestore, doc, docSnapshots} from '@angular/fire/firestore';
import {DocumentData, DocumentSnapshot} from 'rxfire/firestore/interfaces';
import {Database, get, ref} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  headers: HttpHeaders;
  apiUrl: string;
  userId: string;
  userInfoPath: string;
  auth: Auth;

  constructor(private http: HttpClient, private store: Store, private afApp: FirebaseApp, private firestore: Firestore,
              private db: Database) {
    this.apiUrl = environment.apiUrl;
    this.userInfoPath = `superusers`;
    this.auth = getAuth(this.afApp);
  }

  getUserData(userId): Observable<DocumentSnapshot<DocumentData>> {
    if (!userId) {
      return throwError({message: 'You are not authenticated, please refresh the page!'});
    }

    const userDoc = doc(this.firestore, this.userInfoPath, userId);
    return docSnapshots(userDoc);
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  getAllUsers() {
    return lastValueFrom(this.http.get(this.getUrl('auth/list-all-users')));
  }

  async getUserStats(): Promise<any> {
    const path = `carvryStats/users`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }
}
